import { topics } from "@/mocks/homeData";

export default function TopicSection() {
  return (
    <section id="topics" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.28em] text-accent-700">
              <i className="ri-folder-open-line" />
              新料专题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              同一件事，收在一个专题里
            </h2>
            <p className="mt-3 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">
              零散的更新按题材重新归类，沿着时间线往下读，不用来回翻找。
            </p>
          </div>
          <span className="rounded-full border border-background-300 bg-background-50 px-4 py-1.5 font-label text-xs text-foreground-600">
            共 4 个进行中专题
          </span>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          {topics.map((topic) => (
            <article
              key={topic.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <a href="#top" className="block cursor-pointer">
                <div className="h-48 w-full overflow-hidden bg-background-200 md:h-56">
                  <img
                    src={topic.image}
                    alt={`${topic.title}专题配图`}
                    title={`黑料网1 ${topic.title} 专题合集`}
                    className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-2">
                    <span className="rounded bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-800">
                      {topic.tag}
                    </span>
                    <span className="font-label text-[11px] text-foreground-500">{topic.count}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {topic.title}
                  </h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-2 font-label text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                    进入专题
                    <i className="ri-arrow-right-up-line" />
                  </span>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}